import axiosInstance from "../../services/api";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { formatDate } from "../../utils/helpers";
import CircularProgressBox from "../../components/CircularProgressBox";

const ClassStudentList = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { selectedSession } = useSelector((state) => state.sessions);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [studentSessions, setStudentSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    currentUser.role === "teacher" &&
      currentUser.linkedId?.classTeacherOf &&
      setSelectedClassId(currentUser.linkedId.classTeacherOf?._id);
  }, [currentUser]);

  useEffect(() => {
    const getSessionalStudents = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get(
          `/schools/${currentUser.schoolId}/studentSessions?sessionId=${selectedSession}&classId=${selectedClassId}`,
        );
        setStudentSessions(res.data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    selectedClassId && getSessionalStudents();
  }, [selectedClassId, selectedSession, currentUser]);

  const allFields = [
    { key: "fatherName", label: "Father's Name" },
    { key: "motherName", label: "Mother's Name" },
    { key: "dob", label: "D.O.B" },
    { key: "gender", label: "Gender" },
    { key: "admNo", label: "Admission No." },
    { key: "srNo", label: "S.R. Number" },
    { key: "pen", label: "PEN" },
    { key: "apaarId", label: "Apaar ID" },
    { key: "aadhaarNo", label: "Aadhaar No." },
    { key: "phone", label: "Phone Number" },
    { key: "altPhone", label: "Alternate Phone" },
    { key: "email", label: "Email" },
    { key: "address", label: "Address" },
    { key: "religion", label: "Religion" },
    { key: "socialCategory", label: "Social Category" },
  ];

  const [selectedFields, setSelectedFields] = useState([
    "fatherName",
    "motherName",
    "dob",
    "gender",
  ]);

  const handleFieldChange = (e) => {
    setSelectedFields(e.target.value);
  };

  return (
    <div className="dataTable">
      <div className="topbar">
        <div className="left">
          <strong>
            Class: {currentUser.linkedId?.classTeacherOf?.grade}
            {" - "}
            {currentUser.linkedId?.classTeacherOf?.section}
          </strong>
        </div>
        <div className="right">
          <FormControl className="modifyInput" sx={{ minWidth: 140 }}>
            <Select
              className="filterSelect"
              labelId="field-select-label"
              multiple
              placeholder="Filter Fields"
              value={selectedFields}
              onChange={handleFieldChange}
              renderValue={() => "Filter Fields"}
              style={{
                padding: "0px",
                margin: "0px",
              }}
            >
              {allFields.map((field) => (
                <MenuItem key={field.key} value={field.key}>
                  <Checkbox checked={selectedFields.indexOf(field.key) > -1} />
                  <ListItemText primary={field.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="bottom">
        {studentSessions.length > 0 ? (
          <div className="tableWrapper">
            <table className="customTable">
              <thead>
                <tr>
                  <th style={{ width: "80px" }}>S.No.</th>
                  <th>Student's Name</th>
                  {selectedFields.includes("fatherName") && (
                    <th>Father's Name</th>
                  )}
                  {selectedFields.includes("motherName") && (
                    <th>Mother's Name</th>
                  )}
                  {selectedFields.includes("dob") && <th>D.O.B</th>}
                  {selectedFields.includes("gender") && <th>Gender</th>}
                  {selectedFields.includes("admNo") && <th>Admission No.</th>}
                  {selectedFields.includes("srNo") && <th>S.R. Number</th>}
                  {selectedFields.includes("pen") && <th>PEN</th>}
                  {selectedFields.includes("apaarId") && <th>Apaar ID</th>}
                  {selectedFields.includes("aadhaarNo") && <th>Aadhaar No.</th>}
                  {selectedFields.includes("phone") && <th>Phone Number</th>}
                  {selectedFields.includes("altPhone") && (
                    <th>Alternate Phone</th>
                  )}
                  {selectedFields.includes("email") && <th>Email</th>}
                  {selectedFields.includes("address") && <th>Address</th>}
                  {selectedFields.includes("religion") && <th>Religion</th>}
                  {selectedFields.includes("socialCategory") && (
                    <th>Social Category</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {studentSessions.map((row, i) => (
                  <tr key={row._id}>
                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                    <td>{row?.studentId?.name}</td>
                    {selectedFields.includes("fatherName") && (
                      <td>{row.studentId?.fatherName}</td>
                    )}
                    {selectedFields.includes("motherName") && (
                      <td>{row.studentId?.motherName}</td>
                    )}
                    {selectedFields.includes("dob") && (
                      <td style={{ textAlign: "center" }}>
                        {formatDate(row.studentId?.dob)}
                      </td>
                    )}
                    {selectedFields.includes("gender") && (
                      <td>{row.studentId?.gender}</td>
                    )}
                    {selectedFields.includes("admNo") && (
                      <td>{row.studentId?.profileInfo?.admNo}</td>
                    )}
                    {selectedFields.includes("srNo") && (
                      <td>{row.studentId?.profileInfo?.srNo}</td>
                    )}
                    {selectedFields.includes("pen") && (
                      <td>{row.studentId?.profileInfo?.pen}</td>
                    )}
                    {selectedFields.includes("apaarId") && (
                      <td>{row.studentId?.profileInfo?.apaarId}</td>
                    )}
                    {selectedFields.includes("aadhaarNo") && (
                      <td>{row.studentId?.profileInfo?.aadhaarNo}</td>
                    )}
                    {selectedFields.includes("phone") && (
                      <td>{row.studentId?.contactInfo?.phone}</td>
                    )}
                    {selectedFields.includes("altPhone") && (
                      <td>{row.studentId?.contactInfo?.altPhone}</td>
                    )}
                    {selectedFields.includes("email") && (
                      <td>{row.studentId?.contactInfo?.email}</td>
                    )}
                    {selectedFields.includes("address") && (
                      <td>{row.studentId?.contactInfo?.address}</td>
                    )}
                    {selectedFields.includes("religion") && (
                      <td>{row.studentId?.otherInfo?.religion}</td>
                    )}
                    {selectedFields.includes("socialCategory") && (
                      <td>{row.studentId?.otherInfo?.socialCategory}</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>No record found!</div>
        )}
      </div>
      {loading && <CircularProgressBox />}
    </div>
  );
};

export default ClassStudentList;
